import { redirect } from 'react-router-dom';
import Cookies from 'js-cookie';

export const hasValidAuthToken = () => {
    try {
        if (Cookies.get('_au')) return true;
    } catch (_) {
    }
    return false;
};

export const authLoader = ({ request }) => {
    const url = new URL(request.url);

    if (url.searchParams.has('code')) return null;

    if (hasValidAuthToken()) return null;

    const returnTo = `${url.pathname}${url.search}${url.hash}`;
    if (returnTo && returnTo !== '/') {
        return redirect(`/?returnTo=${encodeURIComponent(returnTo)}`);
    }
    return redirect('/');
};
